import { useShallow } from 'zustand/react/shallow'
import { useBooksStore } from './booksStore'

/**
 * Production subscription used by the app shell.
 *
 * Keeping this hook shared with the performance probe ensures selector
 * measurements follow future subscription changes instead of copying an old
 * selector shape into the benchmark.
 *
 * The app shell only needs the initializer and the ready flag; selecting just
 * those keeps unrelated store updates from re-rendering the route tree.
 */
export const useAppBooksStoreSubscription = () => useBooksStore(useShallow(state => ({
  initializeDB: state.initializeDB,
  dbInitialized: state.dbInitialized,
})))

/** Production subscription used by LedgerStudioView and its perf probe. */
export const useLedgerStudioBooksStoreSubscription = (bookId: string, chapterId: string) => (
  useBooksStore(useShallow(state => ({
    book: state.getBook(bookId),
    chapter: state.getChapter(chapterId),
    books: state.books,
    chapters: state.chapters,
    witnesses: state.getChapterWitnesses(chapterId),
    allWitnesses: state.witnesses,
    sourceObjects: state.sourceObjects,
    loadWitnesses: state.loadWitnesses,
    setCurrentBook: state.setCurrentBook,
    setCurrentChapter: state.setCurrentChapter,
    updateBook: state.updateBook,
    updateChapter: state.updateChapter,
    createWitness: state.createWitness,
    updateWitness: state.updateWitness,
  })))
)
